import { render, staticRenderFns } from "./NotificationContainer.vue?vue&type=template&id=4ba83d0e&scoped=true&"
import script from "./NotificationContainer.vue?vue&type=script&lang=js&"
export * from "./NotificationContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../store-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba83d0e",
  null
  
)

export default component.exports